<mat-drawer role="region" #details [position]="'end'" [mode]="'over'" [opened]="isOpen$ | async">
  <mat-toolbar>
    <mat-toolbar-row>
      {{ headerTitle$ | async }}
      <span class="toolbar-spacer"></span>
      <button mat-icon-button (click)="closeSidepanel()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <ng-container #content></ng-container>
</mat-drawer>
